export const MessageSvg = (props) => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 29 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.375 19.375C25.375 20.0601 25.1204 20.7172 24.6672 21.2017C24.214 21.6862 23.5993 21.9583 22.9583 21.9583H8.45833L3.625 27.125V6.45833C3.625 5.77319 3.87961 5.11611 4.33283 4.63164C4.78604 4.14717 5.40073 3.875 6.04167 3.875H22.9583C23.5993 3.875 24.214 4.14717 24.6672 4.63164C25.1204 5.11611 25.375 5.77319 25.375 6.45833V19.375Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
